import AppTable from "@lib/components/MiniComponents/Table/AppTable";
import { ApiParams } from "@lib/types/Api";
import { useMemo } from "react";
import useIntl from "react-intl/lib/src/components/useIntl";
import { useNavigate } from "react-router-dom";
import getColumns from "./columns";
import { Typography } from "antd";
import { StyledExpandedCard } from "@lib/components/StyledComponents";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { useQuery } from "@tanstack/react-query";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { XAICall } from "@lib/types/xAI";
import { apiGetXAICallLogs } from "@lib/api/xAI";
import { FormattedMessage } from "react-intl";

type Props = {
  item?: XAICall;
};

export default function TftSalesCallLogs({ item }: Props) {
  const { messages } = useIntl();
  const navigate = useNavigate();

  const params: ApiParams = {
    limit: 3,
    sort: "createdAt,DESC",
    filter: [`callLogId||$eq||${item?.callId}`],
    join: ["lead", "customer"],
  };

  const xaiCallLogsQuery = useQuery({
    queryFn: () => apiGetXAICallLogs(params),
    queryKey: ["xai-call-logs", JSON.stringify(params)],
    enabled: !!params && !!item?.callId,
  });

  const { data, isLoading, isFetching, refetch } = xaiCallLogsQuery;
  const apiData = data?.data?.data;

  const columns = useMemo(
    () =>
      getColumns({
        apiData,
        messages,
        navigate,
      }),
    [apiData, params],
  );

  return (
    <StyledExpandedCard>
      <AppTable
        dataSource={apiData}
        columns={columns}
        rowKey={"id"}
        loading={isLoading || isFetching}
      />
      <StyledFlex style={{ justifyContent: "space-between" }}>
        <Typography style={{ marginTop: 10 }}>
          {messages["common.callId"] as string} : <i>{item?.callId}</i>
          {" - "}
          <FormattedMessage
            id="common.showingLastXItems"
            values={{ x: params.limit }}
          />
        </Typography>

        <ActionButton
          type="refresh"
          noLabel
          noBg
          size="small"
          onClick={() => refetch()}
          disabled={isFetching}
          loading={isFetching}
          query={xaiCallLogsQuery}
        />
      </StyledFlex>
    </StyledExpandedCard>
  );
}
